var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.tabOtion),function(item){return _c('el-tab-pane',{key:item.name,attrs:{"label":item.label,"name":item.name}},[_c(item.component,{tag:"component"})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }